export function sourcesReducer(sources = {}, action) {

  switch (action.type) {
    default:
      return sources;
  }
}
